import { RdsTabulationSortOptions } from './tabulation-sort-options.model';
import { TabulationTotalsOptions } from './tabulation-totals-options.model';

/**
 * Describes extra options for tabulation.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
export interface TabulationOptions {
  totals: TabulationTotalsOptions;
  sort: RdsTabulationSortOptions;
  filterEmpty?: boolean;
}
